import Vue from 'vue'
import Vuex from 'vuex'
import utils from '../common/js/util.js'

Vue.use(Vuex)
Vue.use(utils)

const state = {
  reloadFile: null,
  reloadVision: null,
  attrData: null,
  zindex: 2002,
  modals: [],
  fileManage: {
    isVersionData: false
  },
  leftMenuStatus: true,
  userInfo: {
    name: '',
    pwd: ''
  },
  userObj: null, // 当前登陆对象信息
  glid: '',
  chatLoginUser: null,
  glid: '',
  perList: [],
  alertList: [],
  addMember: [],
  userHead: '',
  mapFold: null, //地图折叠，属性页面用
  resetview: false,
  modelClickPos: null,
  orgAllUser: null,  //组织架构信息
  playPathBtn: false,
  pathControl: false,
  pathControl: false,
  is3dOpen: true,
  changeModel: 0,
  gifs: '',
  selVideoId: null,
  eqData: null,
  meterStatus: false
}
// 同步
const mutations = {
  SET_ORGAllUSER: (state, data) => {
    state.orgAllUser = data
  },
  setMeterStatus(state, data) {
    state.meterStatus = data
  },
  setEqData(state, data) {
    state.eqData = data
  },
  setSelVideo(state, data) {
    state.selVideoId = data
  },
  setGif: (state, data) => {
    state.gifs = data
  },
  change3D: (state, data) => {
    state.changeModel = data
  },
  set3d: (state, data) => {
    state.is3dOpen = data
  },
  setModelClickPos(state, data) {
    state.modelClickPos = data
  },
  showPathControl(state, n) {
    state.pathControl = n
  },
  showPlayPathBth(state, n) {
    state.playPathBtn = n
  },
  resetView(state, n) {
    state.resetview = n
  },
  addMember(state, n) {
    state.addMember = n
  },
  setUserHead(state, n) {
    state.userHead = n
  },
  setMapFold(state, data) {
    state.mapFold = data
  },
  setPerList(state, n) {
    state.perList = n
  },
  setAlertList(state, n) {
    state.alertList = n
  },
  userInfo(state, n) {
    state.userInfo.name = n.name
    state.userInfo.pwd = n.pwd
  },
  setUserObj(state, data) {
    state.userObj = data
    let obj = {
      UserName: data.account,
      userNickName: data.name,
      dept: data.MainDepartmentName,
      email: data.email,
      phone: data.telephone,
      level: data.MainPositionName
    }
    state.chatLoginUser = obj
  },
  setGlid(state, n) {
    state.glid = n
  },
  syncAttrData(state, n) {
    state.attrData = n
  },
  hideChat(state, n) {
    state.leftMenuStatus = n
  },
  reloadFile(state, n) {
    state.reloadFile = n
  },
  reloadVision(state, n) {
    state.reloadVision = n
  },
  changeVersion(state, n) {
    state.fileManage.isVersionData = n
  },
  closeModal(state, val) {
    state.modals.map(n => {
      if (n.name === val) {
        utils.removeValue(state.modals, n)
      }
      return state.modals
    })
  },
  setModel(state, val) {
    let name = val.name
    state.modals.splice(state.modals.findIndex(item => item.name === name), 1, val)
  },
  showModal(state, val) {
    state.zindex++
    val.zindex = state.zindex
    if (state.modals.length === 0) {
      state.modals.push(val)
    } else {
      let _flag = state.modals.find(n => {
        return n.name === val.name
      })
      if (_flag) {
        utils.removeValue(state.modals, _flag)
      }
      state.modals.push(val)
      return state.modals
    }
  }
}
const getters = {
  // newDocList: state => {
  //   return state.reloadFile
  // }
}
const actions = {}
const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js